import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

import { ref } from 'vue';
import type { ApiMenuReadMenuItemDto, MenuId, ResourceId } from '@/venit/services/model/techpubs-cms';
import MenuPresenterTree from '@/venit/admin/menu-management/menu-presenter-content-tree.vue';
import ResourcePreviewDialog from '@/venit/components/resources/resource-preview-dialog.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'user-menu-sidebar',
  props: {
    rootMenuId: {}
  },
  emits: ["openMenuContent"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const resourcePreviewId = ref<ResourceId | null>(null);
const resourcePreviewDialog = ref(false);
const resourcePreviewSrc = ref<string | null>(null);
const resourcePreviewTitle = ref<string | null>(null);

const onOpenResourcePreview = (item: ApiMenuReadMenuItemDto) => {
  resourcePreviewId.value = { uuid: item.resourceId };
  resourcePreviewSrc.value = item.url;
  resourcePreviewTitle.value = item.name;
  resourcePreviewDialog.value = true;
};

const onCloseResourcePreview = () => {
  resourcePreviewDialog.value = false;
  resourcePreviewId.value = null;
  resourcePreviewSrc.value = null;
  resourcePreviewTitle.value = null;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(MenuPresenterTree, {
      "root-menu-id": __props.rootMenuId,
      onOpenMenuContent: _cache[0] || (_cache[0] = ($event: any) => (emit('openMenuContent', $event))),
      onOpenResourcePreview: onOpenResourcePreview
    }, null, 8 /* PROPS */, ["root-menu-id"]),
    (resourcePreviewDialog.value)
      ? (_openBlock(), _createBlock(ResourcePreviewDialog, {
          key: 0,
          resourceId: resourcePreviewId.value,
          previewDialog: resourcePreviewDialog.value,
          previewSrc: resourcePreviewSrc.value,
          previewTitle: resourcePreviewTitle.value,
          onCloseDialog: onCloseResourcePreview
        }, null, 8 /* PROPS */, ["resourceId", "previewDialog", "previewSrc", "previewTitle"]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})